import { Department } from '@app/shared/models/department';
import { BaseModel } from '@app/shared/models/base';
import { CurrencyCode } from '@app/shared/models/currency_code';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';


export class Client extends Department {
    public customer_number: string;
    public timezone: string;
    public application: string;
    public locale: ClientLocale;
    public vat: number;
    public userLicenseCount: number;
    public contentstoreRepositoryModel: 'JCR' | 'CEPH' | undefined;

    public readonly trans: any = {
        customer_number: marker('client.customer_number'),
        system_id: marker('client.system_id')
    };

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            productVariants: json && json.productVariants ? json.productVariants : [],
            locale: new ClientLocale(json && json.locale)
        });
    }
}

export class ClientLocale extends BaseModel {
    public country: string;
    public currency_code: CurrencyCode;
    public currency_display_name: string;
    public currency_fraction_digits: number;
    public currency_symbol: string;
    public date_format: string;
    public decimal_separator: string;
    public language: string;
    public short_date_format: string;
    public thousand_separator: string;
    public time_format: string;
    public timestamp_format: string;
    public timezone: string;

    constructor(json?: any) {
        super(json);
    }
}
